import Access from './access'
import AccessOverview from './overview'
import AccessWizard from './wizard'
module.exports = {
  Access,
  AccessOverview,
  AccessWizard
}



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/middlewares/access/index.js